import {BaseContainerModel} from '../base-container.model';
import { bl_applet_to_applet_dependency_link_RowClass } from '../../dbschema/bl_applet_to_applet_dependency_link.model';

export class AppletToAppletDependencyLinkModel extends BaseContainerModel {
    bl_applet_to_applet_dependency_link: bl_applet_to_applet_dependency_link_RowClass = new bl_applet_to_applet_dependency_link_RowClass();
}
